import { Controller } from "@hotwired/stimulus"
import { CurrencyHelper } from "~/helpers/currency_helper"

export default class extends Controller {
  static get targets() {
    return ["monthlyLimit", "creditsForLimit", "monthlyAmount"]
  }

  static get values() {
    return {
      creditsPerPack: Number,
      pricePerPack: Number,
      currency: String,
    }
  }

  connect() {
    this.updateMonthlyAmount()
  }

  calculateCreditsForLimit() {
    const monthlyLimit = Number(this.monthlyLimitTarget.value)
    const numberOfPacks = Math.floor(monthlyLimit / this.pricePerPackValue)
    const creditsForLimit = numberOfPacks * this.creditsPerPackValue
    this.creditsForLimitTarget.textContent = creditsForLimit
  }

  updateMonthlyAmount() {
    const monthlyLimit = Number(this.monthlyLimitTarget.value)
    this.monthlyAmountTarget.textContent = CurrencyHelper.numberToCurrency(monthlyLimit, this.currencyValue)

    this.calculateCreditsForLimit()
  }
}
